import React from 'react';
import { useNavigate } from 'react-router-dom';

const AboutUs = () => {
    const navigate = useNavigate();

    const handleLearnMore = () => {
        navigate('/learn-more'); // Replace with the desired route
    };

    return (
        <section id="about" className="about-container">
            <div className="about-content">
                <h2>About Us</h2>
                <p>
                    At FinTechForge, we merge innovative technology with robust financial tools to provide
                    the best solutions for our clients. Learn more about our vision and mission.
                </p>
                <button onClick={handleLearnMore} className="btn">Learn More</button>
            </div>
        </section>
    );
};

export default AboutUs;
